import { useCallback } from 'react'
import { Season } from '../../types/catalog'
import { ActionsCell, TD, TR } from '../../components/ui/Table'
import { Button } from '../../components/ui/Button'

const MONTH_NAMES = [
  '',
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]
interface Props {
  item: Season
  onEdit: (item: Season) => void
  onDelete: (item: Season) => void
}
export function SeasonRow({ item, onEdit, onDelete }: Props) {
  const handleEdit = useCallback(() => onEdit(item), [item, onEdit])
  const handleDelete = useCallback(() => onDelete(item), [item, onDelete])

  return (
    <TR>
      <TD>
        <code style={{ fontSize: 12, color: '#9b6bb5' }}>{item.code}</code>
      </TD>
      <TD>{item.translations.find(t => t.locale === 'en')?.name ?? '—'}</TD>
      <TD>{item.translations.find(t => t.locale === 'es')?.name ?? '—'}</TD>
      <TD style={{ color: '#9b6bb5', fontSize: 12 }}>
        {MONTH_NAMES[item.startMonth]} → {MONTH_NAMES[item.endMonth]}
      </TD>
      <TD>{item.position}</TD>
      <ActionsCell>
        <Button variant="ghost" size="sm" onClick={handleEdit}>
          Edit
        </Button>
        <Button variant="danger" size="sm" onClick={handleDelete}>
          Delete
        </Button>
      </ActionsCell>
    </TR>
  )
}
